const toolsItemsPropsMapping = (i18n, permissions) => [
  {
    id: 'KWPlanner',
    title: i18n.getString(_TL_('Keyword planner')),
    descriptionLine: i18n.getString(_TL_('Research keywords')),
    helpId: 'pop_BA_CampaignCreate_Goals_KWPlanner',
    iconName: 'Search',
    'aria-label': i18n.getString(_TL_('Research keywords with the Keyword Planner Tool')),
    helpArialLabel: 'Learn more about Research keywords with the Keyword Planner Tool',
    siteMapId: 'keyword-planner',
    siteMapAvailable: () => true,
    isEnabled: true,
  },
  {
    id: 'ImportFile',
    title: i18n.getString(_TL_('Import file')),
    descriptionLine: i18n.getString(_TL_('Import from a file')),
    helpId: 'pop_BA_CampaignCreate_Goals_ImportFile',
    iconName: 'Import',
    'aria-label': i18n.getString(_TL_('Import from a file')),
    helpArialLabel: 'Learn more about Import from a file',
    siteMapId: 'import-file',
    siteMapAvailable: () => true,
    isEnabled: true,
  },
  {
    id: 'GoogleImport',
    title: i18n.getString(_TL_('Google import')),
    descriptionLine: i18n.getString(_TL_('Import from Google Ads')),
    helpId: 'pop_BA_CampaignCreate_Goals_GoogleImport',
    iconName: 'Import',
    'aria-label': i18n.getString(_TL_('Import from Google AdWords')),
    helpArialLabel: 'Learn more about Import from Google AdWords',
    siteMapId: 'import-google',
    siteMapAvailable: () => true,
    isEnabled: permissions && !permissions.IsDomesticSimplifiedChineseEnabled,
  },
  {
    id: 'FreeCoach',
    title: i18n.getString(_TL_('Free coach')),
    descriptionLine: i18n.getString(_TL_('Free coaching on creating a campaign')),
    helpId: 'pop_BA_CampaignCreate_Goals_Coaching',
    analyticsId: 'free-coaching',
    iconName: 'Phone',
    'aria-label': i18n.getString(_TL_('Free coaching on creating a campaign')),
    helpArialLabel: 'Learn more about Free coaching on creating a campaign',
    siteMapAvailable: () => false,
    isEnabled: true,
  },
];

export const toolsConfig = ({ i18n, permissions }) => {
  const toolsItems = toolsItemsPropsMapping(i18n, permissions);

  return toolsItems.filter(item => item.isEnabled);
};

